<template>
    <v-layout wrap>
        <v-flex class="mb-4 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('tree-details') }}</h1>
            </div>
        </v-flex>
        <!-- Add/Edit Tree Node -->
        <v-form class="flex xs12 mb-3" @submit.prevent="saveTree">
            <v-card>
                <v-container grid-list-lg>
                    <v-layout wrap>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('code')"
                                          v-model.number="tree.id"
                                          v-validate="'required|numeric'"
                                          :data-vv-as="$t('code')"
                                          readonly
                                          :error-messages="errors.collect('id')"
                                          name="id"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('arabic-name')"
                                          v-model="tree.arLabel"
                                          v-validate="'required|max:50'"
                                          :data-vv-as="$t('arabic-name')"
                                          :error-messages="errors.collect('arLabel')"
                                          name="arLabel"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('english-name')"
                                          v-model="tree.enLabel"
                                          v-validate="'required|max:50'"
                                          :data-vv-as="$t('english-name')"
                                          :error-messages="errors.collect('enLabel')"
                                          name="enLabel"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-select :label="$t('TreeType')"
                                      v-model="tree.type"
                                      v-validate="'required'"
                                      :data-vv-as="$t('type')"
                                      :error-messages="errors.collect('type')"
                                      :items="nodeTypes"
                                      name="type"></v-select>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-select :label="$t('parent')"
                                      :items="treeList"
                                      v-model.number="tree.parent"
                                      :data-vv-as="$t('parent')"
                                      :error-messages="errors.collect('parent')"
                                      name="parent"
                                      :item-text="getLabelByLang('enLabel', 'arLabel')"
                                      item-value="id"></v-select>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('TableName')" v-model="tree.name" name="name"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('path')"
                                          v-model="tree.path"
                                          v-validate="'max:50'"
                                          :data-vv-as="$t('path')"
                                          :error-messages="errors.collect('path')"
                                          name="path"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('FTP-User-Name')"
                                          v-model="tree.ftpUserName"
                                          name="ftpUsername"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field type="password"
                                          :label="$t('FTPPassword')"
                                          v-model="tree.ftpPassword"
                                          name="ftpPassword"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-select :items="storageTypes"
                                      :label="$t('storageType')"
                                      v-model="tree.storageType"
                                      data-vv-as="Storage Type"
                                      :error-messages="errors.collect('storageType')"
                                      name="storageType"></v-select>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-select :items="processList"
                                      :label="$t('Process')"
                                      v-model="tree.processID"
                                      :item-text="getLabelByLang('enName', 'arName')"
                                      item-value="id"></v-select>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-select :items="fileNameStrategys"
                                      :label="$t('file-Name-Strategy')"
                                      v-model="tree.fileNameStrategy"
                                      :error-messages="errors.collect('fileNameStrategy')"
                                      name="fileNameStrategy"
                                      solo></v-select>
                        </v-flex>  
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('retintionPeriod')"
                                          v-model="tree.retintionPeriod"
                                          :data-vv-as="$t('retintionPeriod')"
                                          :error-messages="errors.collect('retintionPeriod')"
                                          name="retintionPeriod"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-switch v-model="tree.encrypt" :label="$t('Encrypt')"></v-switch>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-switch v-model="tree.enableLabel" :label="$t('EnableAddDefaultLabel')"></v-switch>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-switch v-model="tree.archivingStage" :label="$t('archivingStage')"></v-switch>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-switch v-model="tree.isInstanceVersions" :label="$t('isInstanceVersions')"></v-switch>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-switch v-model="tree.isPageVersions" :label="$t('isPageVersions')"></v-switch>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-switch v-model="tree.isBarcode" :label="$t('isBarcode')"></v-switch>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn color="primary" type="submit">{{ $t('save') }}</v-btn>
                            <v-btn color="primary" :to="{ name: 'define-tree' }">{{ $t('cancel') }}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-form>
    </v-layout>
</template>

<script>
    import TreeService from "@/services/Archiving/TreeService";
    import ProcessService from "@/services/WorkFlow/ProcessService";

    export default {
        name: "tree-details",
        data() {
            return {
                selected: [],
                treeList: [],
                tree: {
                    id: 0,
                    parent: 0,
                    enLabel: null,
                    arLabel: null,
                    type: null,
                    name: null,
                    path: null,
                    encrypt: false,
                    ftpUserName: null,
                    ftpPassword: null,
                    storageType: 0,
                    processID: 0,
                    enableLabel: true,
                    archivingStage: false,
                    isInstanceVersions: false,
                    isPageVersions: false,
                    isBarcode: false,
                    fileNameStrategy: 0,
                    retintionPeriod:0
                },
                nodeTypes: [
                    { text: "Tree", value: 1 },
                    { text: "Cabinet", value: 2 },
                    { text: "Drawer", value: 3 },
                    { text: "Folder", value: 4 },
                    { text: "Document", value: 5 }
                ],
                storageTypes: [
                    { text: "Shared Folder", value: 1 },
                    { text: "FTP", value: 2 },
                    { text: "Cloud", value: 3 }
                ],
                fileNameStrategys: [
                    { text: "ASIS File Name Uploads", value: 1 },
                    { text: "Random Name", value: 2 }
                ],
                processList: []
            };
        },
        async created() {
            this.treeList = (await TreeService.searchNode({ treeID: 0, keyWord: '', SearchType: 1 })).data;
            this.processList = (await ProcessService.getProcesses()).data;
            const treeId = this.$route.params.id;
            if (treeId) {
                this.$store.dispatch("showLoading");
                const tree = (await TreeService.getTree(treeId)).data;
                this.$store.dispatch("hideLoading");
                if (!tree) this.$router.push({ name: "define-tree" });
                this.tree = { ...this.tree, ...tree };
            }
        },
        methods: {
            //async saveTree() {
            //    const isValid = await this.$validator.validateAll();
            //    if (isValid) {
            //        /* add loading on save */
            //        this.$store.dispatch("showLoading");
            //        const result = await TreeService.saveTree(this.tree);
            //        this.$store.dispatch("showMessage", {
            //            text: result.data.message
            //        });
            //        this.$store.dispatch("hideLoading");
            //        if (result.data.statusCode === 200) {
            //            this.$router.push({ name: "define-tree" });
            //        }
            //    }
            //}
                 async saveTree() {
                const isValid = await this.$validator.validateAll();
                if (isValid) {
                    /* add loading on save */
                    this.$store.dispatch('showLoading');
                    const result = await TreeService.saveTree(this.tree);
                    if (result.data.statusCode === 200) {
                        this.$store.dispatch('showMessage', { text: result.data.message });
                        this.$router.push({ name: 'define-tree' });
                    } else {
                        this.$store.dispatch('showMessage', { text: result.data.message, color: 'error' });
                        this.$router.push({ name: 'define-tree', color: 'error' });
                    }
                    this.$store.dispatch('hideLoading');
                }
            },
        }
    };
</script>
